// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"forum/components/AcceptPoliciesModal","329":"forum/components/UserPoliciesStateModal"}[chunkId] + ".js";
};